// button contains only text (Add,confirm)
import { Button } from 'gf-ui-components-mui-lib';

const ButtonContainer = ({ disabled, onClick, children, opacity, dataId = '' }: any) => {
  return (
    <Button
      onClick={onClick}
      variant="contained"
      id={dataId}
      sx={{
        display: 'flex',
        background: '#2469F3',
        height: '48px',
        color: 'white',
        fontSize: '14px',
        fontFamily: 'Inter',
        fontWeight: '500',
        boxShadow: 'none',
        padding: '12px',
        opacity: opacity,
        ':hover': {
          boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10), 0px -4px 8px 0px rgba(0, 0, 0, 0.05)',
          background: '#2469F3'
        },
        '&:disabled': {
          background: 'rgba(36, 105, 243, 0.30)',
          color: 'white'
        }
      }}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default ButtonContainer;
